/**
 * @description JS url processing
 * @source:  https://github.com/steamerjs/steamer-browserutils
 */
import global from '../base/global';
import { has } from '../object';
// localStorage 属性名
var LOCATION_PREPROTY = 'location';
// 多登录态当前用户表示'U'
var U_KEY = 'u';
/**
 * get hash
 * @returns {string}     [value]
 */
export function getHash() {
    if (!has(global, LOCATION_PREPROTY)) {
        // node环境目前简单处理，后续需要mock再处理；
        return '';
    }
    return location.hash;
}
/**
 * get host
 * @returns {string}     [value]         // docs.qq.com
 */
export function getHost() {
    if (!has(global, LOCATION_PREPROTY)) {
        // node环境目前简单处理，后续需要mock再处理；
        return '';
    }
    // 这里是特殊情况，可屏蔽私有化整改eslint规则
    // eslint-disable-next-line @tencent/tdoc-standalone/no-use-location-host
    return location.host;
}
/**
 * get hostname
 * @returns {string}     [value]         // docs.qq.com
 */
export function getHostname() {
    if (!has(global, LOCATION_PREPROTY)) {
        // node环境目前简单处理，后续需要mock再处理；
        return '';
    }
    // 这里是特殊情况，可屏蔽私有化整改eslint规则
    // eslint-disable-next-line @tencent/tdoc-standalone/no-use-location-host
    return location.hostname;
}
/**
 * get pathname
 * @returns {string}     [value]         // /excel/Dxxxxxx
 */
export function getPathname() {
    if (!has(global, LOCATION_PREPROTY)) {
        // node环境目前简单处理，后续需要mock再处理；
        return '';
    }
    return location.pathname;
}
/**
 * get origin
 * @returns {string}     [value]         // docs.qq.com
 */
export function getOrigin() {
    if (!has(global, LOCATION_PREPROTY)) {
        // node环境目前简单处理，后续需要mock再处理；
        return '';
    }
    return location.origin;
}
/**
 * get protocol
 * @returns {string}     [value]         // docs.qq.com
 */
export function getProtocol() {
    if (!has(global, LOCATION_PREPROTY)) {
        // node环境目前简单处理，后续需要mock再处理；
        return '';
    }
    return location.protocol;
}
/**
 * get search
 * @returns {string}     [value]         // docs.qq.com
 */
export function getSearch() {
    if (!has(global, LOCATION_PREPROTY)) {
        // node环境目前简单处理，后续需要mock再处理；
        return '';
    }
    return location.search;
}
/**
 * get port
 * @returns {string}     [value]         // docs.qq.com
 */
export function getPort() {
    if (!has(global, LOCATION_PREPROTY)) {
        // node环境目前简单处理，后续需要mock再处理；
        return '';
    }
    return location.port;
}
/**
 * get href
 * @returns {string}     [value]         // docs.qq.com
 */
export function getHref() {
    if (!has(global, LOCATION_PREPROTY)) {
        // node环境目前简单处理，后续需要mock再处理；
        return '';
    }
    return location.href;
}
/**
 * get query param
 * @param  {string} key [key]
 * @returns {string}     [value]
 */
export function getQuery(key, options) {
    if (options === void 0) { options = {
        shouldDecodeURI: false,
    }; }
    if (!has(global, LOCATION_PREPROTY)) {
        // node环境目前简单处理，后续需要mock再处理；
        return '';
    }
    var reg = new RegExp("(\\?|&)".concat(key, "=([^&]*)(#|&|$)"));
    var searchStr = (options === null || options === void 0 ? void 0 : options.shouldDecodeURI) ? decodeURIComponent(getSearch()) : getSearch();
    var result = searchStr.match(reg);
    return !result ? '' : decodeURIComponent(result[2]);
}
/**
 * 获取多登录态参数'u'
 * @returns
 */
export function getU() {
    return getQuery(U_KEY);
}
